import PropTypes from "prop-types";

const YoutubeEmbed = ({ embedId }: any) => (
  <div className="video-responsive">
    <iframe
      width="100%"
      height="420"
      frameBorder="0"
      allowFullScreen
      title="Embedded youtube"
      src={`https://www.youtube.com/embed/${embedId}?modestbranding=1&rel=0`}
      allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    />
  </div>
);

YoutubeEmbed.propTypes = {
  embedId: PropTypes.string.isRequired,
};

export default YoutubeEmbed;
